import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon, BookOpenCheckIcon, CreditCardIcon, LockIcon, SettingsIcon, ShieldCheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
const productImage = 'https://cdn.magicpatterns.com/uploads/55ep87dERiN3JE7ez3FMDn/MOCKUP.png';
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden border-b border-sand bg-base pb-16 pt-12 sm:pb-20 sm:pt-16" data-id="element-112" data-mp="1274orr9pfk8a">
    <div className="absolute inset-x-0 top-0 -z-10 h-64 bg-navy" data-id="element-113" data-mp="sb1axo5hpx5i" />
    <div className="absolute right-0 top-0 -z-10 h-80 w-80 border-b border-l border-teal/25" data-id="element-114" data-mp="s9gj46ak8sbc" />
    <div className="mx-auto max-w-6xl px-4 text-center" data-id="element-115" data-mp="nbyid36p5jef">
      <motion.p initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="inline-flex items-center gap-2 rounded-full border border-teal/35 bg-navy px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-teal" data-id="element-116" data-mp="3d1scj2wkntvr">
        <SettingsIcon className="h-4 w-4" data-id="element-117" data-mp="3o73mw4xwji4w" /> Megapack Mantenimiento Industrial Listo™
      </motion.p>
      <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.08
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.04] text-ink sm:text-6xl md:text-7xl" data-id="element-118" data-mp="399te53cn8qcv">
        Del equipo al aula.<br data-id="element-119" data-mp="35akni7cwh8lj" /><span className="text-teal" data-id="element-120" data-mp="2qjv80ssep7bv">Todo resuelto.</span>
      </motion.h1>
      
      <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mx-auto my-4 max-w-2xl sm:my-6" data-id="element-121" data-mp="2qhqurk8mavyx">
        <img src={productImage} alt="Megapack Mantenimiento Industrial Listo con seis tomos, bonos de taller y módulos premium" className="mx-auto w-full drop-shadow-[0_24px_32px_rgba(0,0,0,.5)]" data-id="element-122" data-mp="2lla8ywow4tp0" />
      </motion.div>
      <div className="flex flex-wrap justify-center gap-2 text-xs font-bold text-ink" data-id="element-123" data-mp="na9yql90f8jc">
        {['Acceso inmediato', 'Hecho para Argentina', 'Pago seguro'].map(item => <span key={item} className="rounded-full border border-sand bg-navy px-3 py-2" data-id="element-124" data-mp="dd592bfyguxs">{item}</span>)}
      </div>
      <div className="mt-7" data-id="element-125" data-mp="1b1fgx72facwt"><Button onClick={scrollToPricing} arrow data-id="element-126" data-mp="1azumrik0svzh">QUIERO MI MEGAPACK AHORA</Button></div>
      <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-127" data-mp="161jbd3e2udf5">
        <span className="inline-flex items-center gap-1.5" data-id="element-128" data-mp="111okgzuaxnu3"><ShieldCheckIcon className="h-4 w-4 text-teal" data-id="element-129" data-mp="114kj6qdz4gjl" /> Garantía 7 días</span>
        <span className="inline-flex items-center gap-1.5" data-id="element-130" data-mp="x0uxc8oood29"><LockIcon className="h-4 w-4 text-teal" data-id="element-131" data-mp="3ltgm7o0v2mna" /> Pago seguro</span>
        <span className="inline-flex items-center gap-1.5" data-id="element-132" data-mp="3lqm2jypo95ux"><CreditCardIcon className="h-4 w-4 text-gold" data-id="element-133" data-mp="3hqah4jphj1ie" /> Mercado Pago</span>
      </div>
      <p className="mt-5 inline-flex items-center gap-2 text-xs font-semibold text-muted" data-id="element-134" data-mp="1xa42nb9pqei1"><BadgeCheckIcon className="h-4 w-4 text-teal" data-id="element-135" data-mp="21amuh5blvkk8" /><BookOpenCheckIcon className="h-4 w-4 text-teal" data-id="element-136" data-mp="21bftfk4bp5rt" /> Para docentes de mantenimiento y técnicas industriales</p>
    </div>
  </section>;
}